import React, { useState, useCallback, useEffect } from 'react';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import ConversationInteractionPerformanceChart from './ConversationInteractionPerformanceChart';

const ConversationInteractionPerformanceChartContainer = ({
  scenarioId,
  groupId,
  interactions,
  question,
}) => {
  const [hoveredInteractionId, setHoveredInteractionId] = useState(null);
  const [responsesByInteractionId, setResponsesByInteractionId] = useState({});
  const [loading, setLoading] = useState(false);
  const updateResponses = useCallback(
    ({ responses }) => {
      if (!responsesByInteractionId[hoveredInteractionId]) {
        setResponsesByInteractionId({
          ...responsesByInteractionId,
          [hoveredInteractionId]: responses,
        });
      }
    },
    [hoveredInteractionId, responsesByInteractionId],
  );
  const route =
    routes.ON_DEMAND_PRACTICE.CREATOR.CONVERSATIONS.QUESTIONS.INTERACTIONS.METRICS_DETAILS(
      question.id,
      hoveredInteractionId,
      groupId,
    );
  useEffect(() => {
    const requestData = () => {
      setLoading(true);
      request
        .get(route)
        .then(data => {
          updateResponses(data);
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
        });
    };

    if (
      hoveredInteractionId &&
      !responsesByInteractionId[hoveredInteractionId] &&
      !loading
    ) {
      requestData();
    }
  }, [
    groupId,
    scenarioId,
    hoveredInteractionId,
    responsesByInteractionId,
    updateResponses,
    route,
    loading,
  ]);

  useEffect(() => {
    setResponsesByInteractionId({});
  }, [groupId]);

  return (
    <div className="OnDemandPracticeEngagementOverviewGraph--container">
      <ConversationInteractionPerformanceChart
        loading={loading}
        responses={responsesByInteractionId[hoveredInteractionId] || []}
        responsesByInteractionId={responsesByInteractionId}
        interactions={interactions}
        setHoveredInteractionId={setHoveredInteractionId}
      />
    </div>
  );
};
export default ConversationInteractionPerformanceChartContainer;
